import { isDefined } from "@clipboard-health/util-ts";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useQuery, type UseQueryOptions, type UseQueryResult } from "@tanstack/react-query";
import { isEmpty } from "lodash";
import { sendBirdSelectors, useSendbirdStateContext } from "sendbird-uikit";

const CHAT_CHANNEL_QUERY_LIMIT = 100;

export function useGetChatChannels(
  options: UseQueryOptions<SendBird.GroupChannel[]> = {}
): UseQueryResult<SendBird.GroupChannel[]> {
  const sendBirdState = useSendbirdStateContext();
  const sdk = sendBirdSelectors.getSdk(sendBirdState);

  return useQuery({
    queryKey: [isEmpty(sdk)],
    queryFn: async () => {
      if (!isDefined(sdk?.GroupChannel)) {
        return [];
      }

      const query = sdk?.GroupChannel.createMyGroupChannelListQuery();

      if (!isDefined(query)) {
        return [];
      }

      query.includeEmpty = true;
      query.memberStateFilter = "joined_only";
      query.order = "latest_last_message";
      query.limit = CHAT_CHANNEL_QUERY_LIMIT;
      return await query.next();
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_CHAT_CHANNELS_FAILURE,
    },
    ...options,
  });
}
